import { Col, Row, Typography } from "antd";
import colors from "constants/colors";

const { Title, Text } = Typography;

const AboutSection: React.FC = () => {
  return (
    <Row
      justify="center"
      align="top"
      style={{
        padding: "3rem 2rem 0 2rem",
        textAlign: "left",
        paddingBottom: 0,
      }}
    >
      <Col xs={24} sm={24} md={20} lg={20}>
        <Title level={3} style={{ color: colors.secondary }}>
          Hvem er
        </Title>
        <Title level={1} style={{ color: "var(--bindeleddet-color)", marginTop: 0 }}>
          Bindeleddet
        </Title>
        <Text style={{ fontSize: "20px" }}>
          Bindeleddet NTNU er et kontaktorgan mellom næringslivet og sivilingeniørstudentene ved Industriell økonomi og
          teknologiledelse (Indøk) og andre sivilingeniørstudier på NTNU.
        </Text>
      </Col>
    </Row>
  );
};

export default AboutSection;
